import PlantOrSBUWiseOperationCyclesAndBestCTs from "./BestCTReport";

export default PlantOrSBUWiseOperationCyclesAndBestCTs